import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/logs/events", { params: { limit: 200 } });
      setEvents(r.data.items);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div data-testid="page-events">
      <PageHeader
        title="Eventos / Manifestações"
        subtitle="Acompanhe o registro das manifestações de Ciência da Operação realizadas automaticamente para as notas de entrada recebidas."
      />
      <div className="px-8 py-6">
        <div className="bg-white border border-border rounded-sm overflow-x-auto">
          <table className="data-table" data-testid="events-table">
            <thead>
              <tr>
                <th>Quando</th>
                <th>Chave NF-e</th>
                <th>Tipo</th>
                <th>Descrição</th>
                <th>cStat</th>
                <th>Status</th>
                <th>Protocolo</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-8 text-muted-foreground"
                  >
                    Carregando...
                  </td>
                </tr>
              )}
              {!loading && events.length === 0 && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-12 text-muted-foreground"
                  >
                    Nenhum evento.
                  </td>
                </tr>
              )}
              {events.map((e) => (
                <tr key={e.id} data-testid={`event-row-${e.id}`}>
                  <td className="text-xs">{fmtDateTime(e.created_at)}</td>
                  <td className="font-mono text-[11px]">{e.chave}</td>
                  <td className="font-mono">{e.tipo_evento}</td>
                  <td className="text-xs">
                    {e.descricao_evento} {e.motivo ? `· ${e.motivo}` : ""}
                  </td>
                  <td>
                    {e.cstat ? (
                      <StatusBadge
                        variant={e.status === "success" ? "success" : "warning"}
                      >
                        {e.cstat}
                      </StatusBadge>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>
                    <StatusBadge
                      variant={
                        e.status === "success"
                          ? "success"
                          : e.status === "error"
                            ? "error"
                            : "warning"
                      }
                    >
                      {e.status === "success"
                        ? "Processado com Sucesso"
                        : e.status === "error"
                          ? "Erro na Solicitação"
                          : "Aguardando Retorno"}
                    </StatusBadge>
                  </td>
                  <td className="font-mono text-xs">{e.n_protocolo || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Events;
